var _circle, _circle2, _path, _path2, _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1894_34099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#D0D4D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1894_34099)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#D0D4D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 27.2C18 25.4327 19.4327 24 21.2 24H74.8C76.5673 24 78 25.4327 78 27.2V92.8C78 94.5673 76.5673 96 74.8 96H21.2C19.4327 96 18 94.5673 18 92.8L18 27.2Z",
    fill: "url(#paint0_linear_1894_34099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 30C24.7163 30 24 30.7163 24 31.6V32.4C24 33.2837 24.7163 34 25.6 34H65.4C66.2837 34 67 33.2837 67 32.4V31.6C67 30.7163 66.2837 30 65.4 30L25.6 30ZM25.6 37C24.7163 37 24 37.7163 24 38.6V39.4C24 40.2837 24.7163 41 25.6 41H57.4C58.2837 41 59 40.2837 59 39.4V38.6C59 37.7163 58.2837 37 57.4 37H25.6Z",
    fill: "#D0D4D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1894_34099",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 51,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 51,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1894_34099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9583 70.2501L53.0749 69.3891C53.1138 69.1075 53.1333 68.8209 53.1333 68.5293C53.1333 67.032 52.8027 65.6565 52.1416 64.4028C51.4805 63.1482 50.5861 62.1029 49.4583 61.2668L47.7958 62.9584C47.6208 63.1334 47.4213 63.1774 47.1973 63.0903C46.9741 63.0024 46.8624 62.832 46.8624 62.5793V55.4043C46.8624 55.2487 46.9161 55.1173 47.0234 55.0099C47.13 54.9034 47.2611 54.8501 47.4166 54.8501H54.5916C54.8444 54.8501 55.0143 54.957 55.1014 55.1709C55.1893 55.3848 55.1458 55.589 54.9708 55.7834L53.3083 57.4459C54.2805 58.3209 55.0583 59.3709 55.6416 60.5959C56.2249 61.8209 56.5166 63.1432 56.5166 64.5626C56.5166 65.7682 56.3124 66.8909 55.9041 67.9308C55.4958 68.9714 54.9416 69.9195 54.2416 70.7751C53.9111 71.1445 53.5902 71.2663 53.2791 71.1403C52.968 71.0135 52.8611 70.7168 52.9583 70.2501ZM41.4083 75.1501C41.1555 75.1501 40.9856 75.0432 40.8984 74.8293C40.8106 74.6154 40.8541 74.4112 41.0291 74.2168L42.7208 72.5543C41.7097 71.6793 40.9175 70.6293 40.3443 69.4043C39.7703 68.1793 39.4833 66.857 39.4833 65.4376C39.4833 64.232 39.6874 63.1089 40.0958 62.0683C40.5041 61.0284 41.0583 60.0904 41.7583 59.2543C42.0694 58.8848 42.3856 58.7584 42.7068 58.8751C43.0272 58.9918 43.1388 59.2834 43.0416 59.7501C43.0027 60.0223 42.9685 60.3043 42.9389 60.5959C42.9102 60.8876 42.8958 61.1793 42.8958 61.4709C42.8958 62.9682 43.2217 64.3437 43.8734 65.5974C44.5244 66.852 45.4138 67.8973 46.5416 68.7334L48.2041 67.0418C48.3791 66.8668 48.5736 66.8228 48.7874 66.9099C49.0013 66.9978 49.1083 67.1682 49.1083 67.4209V74.5959C49.1083 74.7515 49.0597 74.8825 48.9624 74.9891C48.8652 75.0964 48.7388 75.1501 48.5833 75.1501H41.4083Z",
    fill: "#4D5659"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1894_34099",
    x1: 48,
    y1: 24,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewing);
export default __webpack_public_path__ + "static/media/reviewing.9132d9ca450487ff390c5b7811d32295.svg";
export { ForwardRef as ReactComponent };